import React from "react";
import "components/General/Appearance.css";
import TextTheme from "components/General/Text/TextTheme";

function AlbumComingSoon() {
    return (
        <div > 
            <TextTheme
                message="Album Coming Soon"
                className="text_medium text_med_grey text_bold"
            />    
        </div>
    );
}

export default AlbumComingSoon;
